package diana.soleil.design.iraniancanadienbazzar.core.data

import diana.soleil.design.iraniancanadienbazzar.core.common.DataResult
import diana.soleil.design.iraniancanadienbazzar.core.model.NewsArticle
import kotlinx.coroutines.flow.Flow

/**
 * Community news for the Home carousel. Read-only from the app; articles are published by admins
 * (Firestore `news` collection — see `docs/DATA_MODEL.md` / `docs/ADMIN_RUNBOOK.md`).
 */
interface NewsRepository {
    /**
     * Streams visible articles newest-first. Metro-targeted articles are included only for the
     * active metro; national articles (`metroId == null`) always show.
     */
    fun observeNews(metroId: String?, limit: Int = 20): Flow<DataResult<List<NewsArticle>>>

    /** One-shot read for the detail screen. */
    suspend fun getArticle(articleId: String): DataResult<NewsArticle>
}
